import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CTAButton({
  label,
  sublabel,
  id,
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-accent text-white shadow-[0_6px_0_#C9520A] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-[#FF8A33] active:translate-y-[4px] active:shadow-[0_2px_0_#C9520A] focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/40 ${size === 'lg' ? 'px-5 py-4 sm:py-5' : 'px-5 py-3.5'} ${className}`} data-id="element-29" data-mp="2fy0dzjnjajxf">
      <span className="flex flex-col items-center text-center" data-id="element-30" data-mp="3cqnja7sruq93">
        <span className={`font-display font-extrabold uppercase leading-tight tracking-wide ${size === 'lg' ? 'text-[17px] sm:text-xl' : 'text-base sm:text-lg'}`} data-id="element-31" data-mp="38oshz3auccvb">
          {label}
        </span>
        {sublabel && <span className="mt-1 text-[13px] font-semibold text-white/90 sm:text-sm" data-id="element-32" data-mp="1d9q7dzfe6qvw">{sublabel}</span>}
      </span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-33" data-mp="1i8jixmb4c7tf" />
    </a>;
}